namespace Areas.Warranty.Items {
    "use strict";

 
    export function onNewWarrantyItemRow(e: any) {
        e.data.warrantyProfileId = e.component.option("WarrantyProfileId");
           }

    export function updateWarrantyListItem() {
        const grid = $("#WarrantyItemGrid").dxForm("instance");
        const newData: any = grid.option("gridData");
        const result: any = grid.validate();
        const keyId: any = grid.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Warranty/Items/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }


    export function returnToListFromTab() {
        var linkInfo = "/Warranty/List/Active";
        location.href = linkInfo;

    }

    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }


    function goToSharePoint(sharePointLink) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

}